<div class="page" (keydown.enter)="doSearch($event)">
  <div class="search-header">
    <div class="search-header__title">企業検索</div>
    <div class="search-header__close close" (click)="onCloseClick()"></div>
  </div>

  <div class="content">
    <div class="row">
      <div class="row__column keyword">
        <div class="header keyword__header">
          <div class="header__title">キーワード</div>
        </div>
        <div class="keyword__input-container">
          <input
            class="keyword__input"
            type="text"
            [(ngModel)]="searchModel.keyword"
          />
          <div class="keyword__hint">
            ※キーワード検索対象：企業名、企業カナ、企業ID、企業No、備考
          </div>
        </div>
      </div>
      <div class="row__column"></div>
    </div>

    <div class="row">
      <div class="row__column">
        <ag-dynamic-form
          *ngIf="metadataLeft"
          class="dynamic-form"
          [metadata]="metadataLeft"
          [model]="innerSearchModel"
        ></ag-dynamic-form>
      </div>
      <div class="row__column">
        <ag-dynamic-form
          *ngIf="metadataRight"
          class="dynamic-form"
          [metadata]="metadataRight"
          [model]="innerSearchModel"
        ></ag-dynamic-form>
      </div>
    </div>
  </div>

  <div class="content content--bg-gray" *ngIf="metadataCustomFields">
    <div class="row">
      <div class="row__column">
        <ag-dynamic-form
          class="dynamic-form"
          [metadata]="metadataCustomFields"
          [model]="innerSearchModel"
        ></ag-dynamic-form>
      </div>
    </div>
  </div>
</div>

<div class="footer">
  <button class="footer__btn footer__btn--green" (click)="doSearch()">
    検索
  </button>
</div>
